import { BackFromEditorButton } from 'components/common/BackFromEditorButton'
import { Edit, SimpleForm, useTranslate } from 'react-admin'
import RetailerAddressEditToolbar from './RetailerAddressEditToolbar'
import RetailerAddressFormInputs from './RetailerAddressFormInputs'

const RetailerAddressEdit = (props) => {
    const translate = useTranslate()

    const handleRedirect = (_, __, data) => {
        return `Retailer/${data?.retailer_id}/addresses`
    }

    return (
        <>
            <BackFromEditorButton isPristineForm={true} />
            <Edit
                {...props}
                undoable={false}
                basePath={props.basepath}
                resource={props.resource}
                title={translate(`manager.resources.${props.resource}.edit`)}
                redirect={handleRedirect}
            >
                <SimpleForm
                    defaultValues={{ retailer_id: props?.location?.state?.retailer_id }}
                    toolbar={<RetailerAddressEditToolbar />}
                >
                    <RetailerAddressFormInputs {...props} />
                </SimpleForm>
            </Edit>
        </>
    )
}

export default RetailerAddressEdit
